import React, { useEffect, useState } from 'react';
import { getImpersonation, endImpersonation } from 'services/impersonation';

// Compact indicator rendered inside the header topbar while impersonating.
export default function ImpersonationBadge() {
  const [now, setNow] = useState(Date.now());
  const session = getImpersonation();
  const active = Boolean(session);
  useEffect(() => {
    if (!active) return undefined;
    const timer = window.setInterval(() => setNow(Date.now()), 15000);
    return () => window.clearInterval(timer);
  }, [active]);
  if (!session || session.expiresAt <= now) return null;
  const minutes = Math.max(1, Math.ceil((session.expiresAt - now) / 60000));
  return (
    <div
      className="kt-header__topbar-item"
      aria-label="Sesión de soporte"
      title={`Operando como ${session.username}. Los cambios que guardes se aplican a su cuenta.`}
      style={{ alignItems: 'center', padding: '0 8px' }}
    >
      <span
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 8,
          padding: '4px 10px',
          borderRadius: 14,
          background: '#fff3cd',
          color: '#533f03',
          border: '1px solid #ffe08a',
          fontSize: 12,
          lineHeight: '16px',
          whiteSpace: 'nowrap',
        }}
      >
        <i className="fas fa-user-secret" aria-hidden="true" />
        <span>
          Soporte · <strong>{session.username}</strong> · {minutes} min
        </span>
        <button
          type="button"
          onClick={endImpersonation}
          style={{
            border: 0,
            background: 'transparent',
            color: '#533f03',
            textDecoration: 'underline',
            cursor: 'pointer',
            padding: 0,
            font: 'inherit',
          }}
        >
          Salir
        </button>
      </span>
    </div>
  );
}
